import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { Component } from 'react';
var fadeOutStyles = function fadeOutStyles(maxHeight, top, backgroundColor) {
  return css({
    position: 'relative',
    overflowY: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: "".concat(maxHeight, "px"),
    '&::after': {
      content: "''",
      position: 'absolute',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      top: "".concat(top, "px"),
      bottom: 0,
      left: 0,
      right: 0,
      backgroundImage: "linear-gradient( ".concat("var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))", ", ", backgroundColor, " )")
    }
  });
};
var FadeOut = function FadeOut(props) {
  var children = props.children,
    backgroundColor = props.backgroundColor,
    fadeHeight = props.fadeHeight,
    height = props.height;
  var top = height - fadeHeight;
  var styles = fadeOutStyles(height, top, backgroundColor);
  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
  return jsx("div", {
    css: styles
  }, children);
};
export var TruncatedWrapper = /*#__PURE__*/function (_Component) {
  _inherits(TruncatedWrapper, _Component);
  var _super = _createSuper(TruncatedWrapper);
  function TruncatedWrapper(props) {
    _classCallCheck(this, TruncatedWrapper);
    return _super.call(this, props);
  }

  // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
  _createClass(TruncatedWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$height = _this$props.height,
        height = _this$props$height === void 0 ? 95 : _this$props$height,
        _this$props$fadeHeigh = _this$props.fadeHeight,
        fadeHeight = _this$props$fadeHeigh === void 0 ? 24 : _this$props$fadeHeigh,
        _this$props$backgroun = _this$props.backgroundColor,
        backgroundColor = _this$props$backgroun === void 0 ? "var(--ds-surface, white)" : _this$props$backgroun,
        children = _this$props.children;
      return jsx(FadeOut, {
        height: height,
        fadeHeight: fadeHeight,
        backgroundColor: backgroundColor
      }, children);
    }
  }]);
  return TruncatedWrapper;
}(Component);